const DAY_MS = 24 * 60 * 60 * 1000;
const DAY_STRING = /^\d{4}-\d{2}-\d{2}$/;

const wallClock = new Intl.DateTimeFormat('tr-TR', {
  timeZone: 'Europe/Istanbul',
  hourCycle: 'h23',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
});

// The Istanbul midnight at or before the instant `ms`: the instant minus the Istanbul wall-clock
// time elapsed since that midnight.
export function istanbulMidnight(ms: number): number {
  const parts = wallClock.formatToParts(ms);
  const part = (type: Intl.DateTimeFormatPartTypes): number =>
    Number(parts.find((p) => p.type === type)?.value);
  const elapsedSeconds = (part('hour') * 60 + part('minute')) * 60 + part('second');
  return ms - elapsedSeconds * 1000 - new Date(ms).getUTCMilliseconds();
}

// Noon UTC of a calendar day falls on that same day in Istanbul (UTC+3).
function noonUtc(day: string): number {
  return Date.parse(`${day}T12:00:00.000Z`);
}

// The first instant of the Istanbul day, in RFC 3339 UTC; a 'YYYY-MM-DD' string is that day.
export function startOfIstanbulDay(value: string | Date): string {
  const ms =
    typeof value === 'string' && DAY_STRING.test(value)
      ? noonUtc(value)
      : new Date(value).getTime();
  return new Date(istanbulMidnight(ms)).toISOString();
}

// The Istanbul days `from` to `to` ('YYYY-MM-DD', both included) as the UTC instants of the first
// and the last millisecond.
export function istanbulDayRange(from: string, to: string): { from: string; to: string } {
  if (from > to) throw new RangeError(`istanbulDayRange: ${from} is after ${to}`);
  return {
    from: startOfIstanbulDay(from),
    to: new Date(istanbulMidnight(noonUtc(to) + DAY_MS) - 1).toISOString(),
  };
}
